export enum StorageProviderType {
  S3 = 's3',
}
